function determineEligibilityOfMembersPrice() {
  const isUserLoggedIn = window.customer?.isLoggedIn;

  try {
    let isUserLoggedInLocalStorage = localStorage.getItem('isUserLoggedIn') || 'false';
    isUserLoggedInLocalStorage = JSON.parse(isUserLoggedInLocalStorage);

    if (
      isUserLoggedInLocalStorage === null ||
      isUserLoggedInLocalStorage === undefined ||
      isUserLoggedInLocalStorage !== isUserLoggedIn
    ) {
      localStorage.setItem('isUserLoggedIn', isUserLoggedIn);
      changeEligibilityOfMembersPrice(isUserLoggedIn);
    }
  } catch (error) {
    console.error("❌ Error determining eligibility of members price:", error);
  }
}

async function changeEligibilityOfMembersPrice(isUserLoggedIn) {
	if (isUserLoggedIn === null || isUserLoggedIn === undefined) return;

	toggleDisabilityCartDrawerIcon(true);
  const isUserLoggedInString = isUserLoggedIn ? 'true' : 'false';

  try {
    let cartItems = (await fetch('/cart.js').then(r => r.json())).items;

    while (true) {
      // Find the next item that needs updating
      const itemToUpdate = cartItems.find(item => {
        const currentValue = item.properties?._is_user_logged_in;
        return currentValue !== isUserLoggedInString;
      });

      if (!itemToUpdate) break;

      const updatedProperties = {};
      for (const key in itemToUpdate.properties) {
        const val = itemToUpdate.properties[key];
        if (val !== undefined) {
          updatedProperties[key] = typeof val === "string" ? val : String(val ?? "");
        }
      }
      updatedProperties["_is_user_logged_in"] = isUserLoggedInString;

      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: itemToUpdate.key,
          quantity: itemToUpdate.quantity,
          properties: updatedProperties,
        }),
      });

      const result = await response.json();

      // Refetch cart to get fresh keys after change
      cartItems = (await fetch('/cart.js').then(r => r.json())).items;
    }

		toggleDisabilityCartDrawerIcon(false);
    window.location.href = window.location.href;

  } catch (err) {
    console.error("❌ Error updating cart items:", err);
  }
}

function toggleDisabilityCartDrawerIcon(disabled) {
	const cartDrawerIcon = document.querySelector('.menu__item--secondary [data-cart-drawer-toggle]');
	if (cartDrawerIcon) {
		cartDrawerIcon.classList.toggle('disabled', disabled);
	}
}

document.addEventListener('DOMContentLoaded', () => {
  determineEligibilityOfMembersPrice();
});
